import { useState, useEffect } from "react";
var delay = 200;
function useWindowWidth() {
    var _a = useState(function () { return window.innerWidth; }), width = _a[0], setWidth = _a[1];
    useEffect(function () {
        var timeoutId;
        var handleResize = function () {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                setWidth(window.innerWidth);
            }, delay);
        };
        window.addEventListener("resize", handleResize);
        // Set initial width
        handleResize();
        return function () {
            clearTimeout(timeoutId);
            window.removeEventListener("resize", handleResize);
        };
    }, [delay]);
    return width;
}
export default useWindowWidth;
